export const TIMEFRAMES = ['Morning', 'Evening', 'Overnight'] as const;

export const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;

export const POSITIONS = [
  'Wellness Nurse',
  'Medication Care Partner',
  'Life Enrichment Assistant',
  'Concierge',
  'Resident Care Partner (PSW)',
  'Housekeeper',
  'Maintenance Assistant',
  'Server',
  'Sous Chef',
  'Cook',
  'Dishwasher',
  'Night Building',
  'Companion',
  'RCP Student',
  'Assistant Cook',
] as const;

export const FULFILLMENT_DASHBOARD_PATH = '/reports/fulfillment';

export const DATA_TABLE_PAGE_SIZE = 10;

export function getFulfillmentBarColor(
  percentage: number,
  chartColors: string[],
  threshold: { attention: string; critical: string },
): string {
  if (percentage >= 85) return chartColors[3] || '#1C0F51';
  if (percentage >= 75) return chartColors[0] || '#4E4785';
  if (percentage >= 65) return '#E8993E';
  return threshold.critical;
}
